import {
  HomeIcon,
  ClockIcon,
  WalletIcon,
  HeartIcon,
  FolderIcon,
  ChartBarIcon,
  ShieldCheckIcon,
  LifebuoyIcon,
  ClipboardDocumentCheckIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";

const employeeSidebarMenu = [
  {
    
    items: [
      {
        label: "Dashboard",
        path: "/dashboard",
        icon: HomeIcon,
      },
    ],
  },

  {
    
    items: [
      {
        label: "Attendance",
        path: "/dashboard/attendancepage",
        icon: ClockIcon,
      },
    //   {
    //     label: "Leave Requests",
    //     path: "/dashboard/leave-requests",
    //     icon: ClipboardDocumentCheckIcon,
    //   },
    ],
  },

  {
   
    items: [
      {
        label: "Payslips",
        path: "/dashboard/pay",
        icon: WalletIcon,
      },
      {
        label: "Bonus & Incentives",
        path: "/dashboard/bonus",
        icon: CurrencyDollarIcon,
      },
      {
        label: "My Benefits",
        path: "/dashboard/my-benefits",
        icon: HeartIcon,
      },
      {
        label: "Expense Reimbursement",
        path: "/dashboard/expense-reimbursement",
        icon: WalletIcon,
      },
    ],
  },

  {
    
    items: [
      {
        label: "My Learnings",
        path: "/dashboard/analytics-dashboard",
        icon: ChartBarIcon,
      },
      {
        label: "Reviews & Appraisals",
        path: "/dashboard/performance-review",
        icon: ClipboardDocumentCheckIcon,
      },
    ],
  },

  {
    
    items: [
      {
        label: "My Documents",
        path: "/dashboard/documents",
        icon: FolderIcon,
      },
      {
        label: "Policies & Compliance",
        path: "/dashboard/Policies",
        icon: ShieldCheckIcon,
      },
      {
        label: "Helpdesk",
        path: "/dashboard/Userhelp",
        icon: LifebuoyIcon,
      },
    ],
  },

  {
    
    items: [
      {
        label: "Offboarding",
        path: "/dashboard/resign",
        icon: LifebuoyIcon,
      },
    ],
  },
];

export default employeeSidebarMenu;
